var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.4898 0 0 4.4898 0 10C0 15.5102 4.4898 20 10 20C15.5102 20 20 15.5102 20 10C20 4.4898 15.5102 0 10 0ZM13.5714 8.4694L9.4898 12.551C9.2857 12.6531 9.1837 12.7551 8.9796 12.7551C8.7755 12.7551 8.5714 12.6531 8.4694 12.551L6.42857 10.5102C6.12245 10.2041 6.12245 9.6939 6.42857 9.3878C6.73469 9.0816 7.2449 9.0816 7.55102 9.3878L9.0816 10.9184L12.6531 7.34694C12.9592 7.04082 13.4694 7.04082 13.7755 7.34694C13.8776 7.7551 13.8776 8.1633 13.5714 8.4694Z",
    fill: "#65CB70"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.ad8a8b60257d6fdeb6ad8eb5f1768dd2.svg";
export { ForwardRef as ReactComponent };